module.exports = __webpack_public_path__ + "static/img/szrl3B.2ec0543.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/szrl3B.jpg
// module id = e7+P
// module chunks = 73